import template from "./pCasemanTeamConfig.html";

export function pCasemanTeamConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanTeamConfigController,
    controllerAs: 'pCasemanTeamConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanTeamConfigController {
  constructor($scope, $interval, Auth, Caseman, Notes, ConnectionQuality) {
    'ngInject';

    this.$scope = $scope;
    this.$interval = $interval;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";

    this.headers = [
      {name: "CASEMAN.TEAM_KLIX", class: null},
      {name: "CASEMAN.TEAM_CASEMAN", class: "table-caseman"}
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => {this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        this.Caseman.getTeamMapper().then(
          (success) => {
            this.teamMapper = success.data;

            if(this.teamMapper.length) {
              this.state = "loadedMapper";
            } else {
              this.state = "loadedNoMapper";
            }
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );

      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }
}